/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FantaPlayerTeam } from '../models/FantaPlayerTeam';
import type { FantaTeamSmall } from '../models/FantaTeamSmall';
import type { PlayerPositionEnum } from '../models/PlayerPositionEnum';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FantaSearchService {
    /**
     * Search Fanta Players
     * Search for players in the Fanta database.
     * @param query
     * @param leagueId
     * @param position
     * @param limit
     * @param offset
     * @returns FantaPlayerTeam Successful Response
     * @throws ApiError
     */
    public static searchFantaPlayers(
        query: string,
        leagueId: number,
        position: PlayerPositionEnum,
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<FantaPlayerTeam>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_search/player',
            query: {
                'query': query,
                'league_id': leagueId,
                'position': position,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Search Fanta Teams
     * Search for Fanta teams in the database.
     * @param query
     * @param regionId
     * @param leagueId
     * @param limit
     * @param offset
     * @param onlyMatching
     * @returns FantaTeamSmall Successful Response
     * @throws ApiError
     */
    public static searchFantaTeams(
        query: string,
        regionId: number,
        leagueId?: (number | null),
        limit: number = 10,
        offset?: number,
        onlyMatching: boolean = false,
    ): CancelablePromise<Array<FantaTeamSmall>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_search/team',
            query: {
                'query': query,
                'region_id': regionId,
                'league_id': leagueId,
                'limit': limit,
                'offset': offset,
                'only_matching': onlyMatching,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
